export const SPOTIFY_AUTH_PAYLOAD_PARAM = 'spotifyAuthPayload';
